module.exports = __webpack_public_path__ + "front/img/33_1.23b138f3.png";